export const STUDENT_MEETING_ROUTE_NAMES = {
  MY_MEETING: "myMeeting",
  MY_STUDENTS: "myStudentsStudentMeetings",
  MY_LESSON_GROUPS: "myLessongroupsStudentMeetings",
  CREATE: "studentMeetingCreate",
  EDIT: "studentMeetingEdit",
  MANAGE: "studentMeeting",
} as const;

export type StudentMeetingRouteName =
  (typeof STUDENT_MEETING_ROUTE_NAMES)[keyof typeof STUDENT_MEETING_ROUTE_NAMES];
